<template>
  <div class='errors'>
    <div class='dummy-input'>
      <div id='card-element'>
        <!-- Stripe elements inserts fields here -->
      </div>
    </div>

    <div v-if='errors.card' class='error'>{{ card_error }}</div>
  </div>
</template>

<script>
  import { loadStripe } from '@stripe/stripe-js'

  export default {
    props: ['express_checkout'],
    async mounted() {
      this.stripe = await loadStripe(window.STRIPE_PUBLISHABLE_KEY)
      const elements = this.stripe.elements({
        fonts: [
          {
            cssSrc: 'https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700&display=swap'
          }
        ]
      })
      this.card = elements.create('card', {
        style: {
          base: {
            fontFamily: 'Roboto Condensed',
            fontWeight: 400,
            fontSize: '18px'
          }
        }
      })
      this.card.mount('#card-element')
    },
    data() {
      return {
        errors: {}
      }
    },
    watch: {
      express_checkout: {
        handler() {
          if (this.express_checkout) {
            this.$set(this.errors, 'card', null)
          }
        },
        immediate: false
      }
    },
    computed: {
      card_error() {
        if (this.errors.card === 'Your postal code is incomplete.') {
          return "Payment method postal code is required (located directly above after your card's CVC)."
        } else {
          return this.errors.card
        }
      }
    },
    methods: {
      uses_payment_intents() {
        return false
      },
      create_token(callback) {
        this.stripe.createToken(this.card).then((result) => {
          if (result.error) {
            this.$set(this.errors, 'card', result.error.message)
          } else {
            this.$set(this.errors, 'card', null)
          }
          callback(result)
        })
      },
    }
  }
</script>
